import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13b32e00")

_pushScopeId("data-v-13b32e00")
const _hoisted_1 = { class: "dossiers" }
const _hoisted_2 = { class: "pagination-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-3 center" }, " Aucun dossier disponible ", -1)
const _hoisted_5 = { class: "pagination-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_simulation_small_card = _resolveComponent("simulation-small-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("dig-input-text", {
      onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.search($event.target.value))),
      hint: $setup.t('filterSimulationHint')
    }, _toDisplayString($setup.t('filterSimulation')), 41, ["hint"]),
    _createVNode("div", _hoisted_2, [
      ($setup.searchedSimulations.length > $setup.elementsPerPage)
        ? (_openBlock(), _createBlock("dig-ui-pagination", {
            key: 0,
            pageCount: Math.ceil($setup.searchedSimulations.length / $setup.elementsPerPage),
            onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.currentPage = $event.detail)),
            currentPage: $setup.currentPage,
            "previous-text": "Prec",
            "next-text": "Suiv"
          }, null, 40, ["pageCount", "currentPage"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.searchedSimulations.filter(
        (s, i) =>
          i >= ($setup.currentPage - 1) * $setup.elementsPerPage &&
          i < $setup.currentPage * $setup.elementsPerPage,
      ), (simulation) => {
      return (_openBlock(), _createBlock(_component_simulation_small_card, {
        key: simulation.id,
        simulation: simulation,
        onDelete: ($event: any) => ($setup.deleteSimulation(simulation.id))
      }, null, 8, ["simulation", "onDelete"]))
    }), 128)),
    (!$setup.searchedSimulations.length)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      ($setup.searchedSimulations.length > $setup.elementsPerPage)
        ? (_openBlock(), _createBlock("dig-ui-pagination", {
            key: 0,
            pageCount: Math.ceil($setup.searchedSimulations.length / $setup.elementsPerPage),
            onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.currentPage = $event.detail)),
            currentPage: $setup.currentPage,
            "previous-text": "Prec",
            "next-text": "Suiv"
          }, null, 40, ["pageCount", "currentPage"]))
        : _createCommentVNode("", true)
    ])
  ]))
})